import { List } from '@hai/ui-react';
import React, { useEffect } from 'react';
import { SortDirection, SortManager } from 'src/js/component/sort-manager';
import { scrollPanelIntoView } from 'src/js/component/actionBar/streaming-action-bar';
import { constant } from 'src/js/util/constant';

import { AudioEncoderViewModel } from './audio-encoder-models';
import { AudioEncoderRow } from './audio-encoder-row';

interface AudioEncoderProps {
  list: AudioEncoderViewModel[];
  direction: SortDirection;
  onSelect: (model: AudioEncoderViewModel, selected: boolean) => void;
  sorting: string;
  sortInfo: any;
  scrollToId: number | string;
}

export const AudioEncoderList: React.FunctionComponent<AudioEncoderProps> = ({
  list,
  direction,
  onSelect,
  sorting,
  sortInfo,
  scrollToId,
}) => {
  useEffect(() => {
    scrollPanelIntoView({ id: scrollToId });
  }, [scrollToId]);

  return (
    <List accentColor={constant.productColor}>
      <SortManager sortInfo={sortInfo} list={list} sortKey={sorting} direction={direction} secondLevelSortKey="name">
        {list &&
          list.map((model: AudioEncoderViewModel) => {
            return <AudioEncoderRow key={model.id} model={model} onSelect={onSelect} scrollToId={scrollToId} />;
          })}
      </SortManager>
    </List>
  );
};
